import React, { useState } from 'react';
import { View, Text, TouchableOpacity, Image } from 'react-native-web';
import Lightbox from 'yet-another-react-lightbox';
import moment from 'moment';
import StarRatings from 'react-star-ratings/build/star-ratings';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import PropTypes from 'prop-types';

// Configs
import GLOBAL from '../configs/config_global';

export function ReviewItem(props) {
    const {
        reviewData,
        parentPadding,
        showTotalResponses,
        shortenReview,
        maxLines,
        showUnreadBadge,
        style
    } = props;

    // region Local State
    const [photoCarouselOpened, setPhotoCarouselOpened] = useState(false);
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
    // endregion

    const hasPhotos = (reviewData.photos || []).length > 0;
    const PHOTO_SIZE = 80;
    const DISPLAY_PHOTO_COUNT = 3;

    const remainingPhotoCount = hasPhotos ? (reviewData.photos.length - DISPLAY_PHOTO_COUNT) : 0;

    return(
        <View style={[{ width: '100%', padding: 24 }].concat(style)}>
            {/* Main Content */}
            <View style={{ alignSelf: 'stretch' }}>
                {/* User Info & Rating */}
                <View style={{ flexDirection: 'row', alignItems: 'flex-start', alignSelf: 'stretch' }}>
                    {/* Avatar */}
                    <Image
                        source={reviewData.user?.avatar ? { uri: reviewData.user?.avatar } : require('../images/image_user_placeholder_round.png')}
                        style={{ width: 64, height: 64, borderRadius: 32, backgroundColor: GLOBAL.COLOR.TEXT_LIGHT_GRAY }}
                        resizeMode={'cover'}
                    />

                    {/* Name and Rating */}
                    <View style={{ flex: 1, marginLeft: 16 }}>
                        {/* Name */}
                        <Text style={{ fontSize: 18, fontWeight: 'bold' }}>
                            {
                                !!reviewData.user?.name?.trim() ?
                                    `${reviewData.user?.name}${(GLOBAL.DATA.USER && (reviewData.user?.email === GLOBAL.DATA.USER.email)) ? ' (You)' : ''}`
                                    :
                                    '(Deleted User)'
                            }
                        </Text>

                        {/* Rating and Date */}
                        <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 8 }}>
                            {/* Stars */}
                            <StarRatings
                                rating={Number(reviewData.rating)}
                                starRatedColor={GLOBAL.COLOR.MAIN}
                                starEmptyColor={GLOBAL.COLOR.BASIC.PINKISH_GREY}
                                numberOfStars={5}
                                starDimension={'18px'}
                                starSpacing={'1px'}
                            />

                            {/* Date */}
                            <Text style={{ color: GLOBAL.COLOR.TEXT_GRAY, fontSize: 14, lineHeight: 18, marginLeft: 6 }}>
                                {moment.utc(reviewData['created_at']).fromNow()}
                                {(reviewData['updated_at'] && (reviewData['created_at'] !== reviewData['updated_at'])) ? `(edited)` : ''}
                            </Text>
                        </View>
                    </View>
                </View>

                {/* Review Text */}
                <Text
                    style={{ color: GLOBAL.COLOR.BASIC.BLACK_TWO, alignSelf: 'stretch', marginTop: 16, lineHeight: 28 }}
                    numberOfLines={shortenReview ? 3 : (maxLines || null)}>
                    {reviewData.comment?.trim()}
                </Text>

                {/* Unread Badge */}
                {
                    (showUnreadBadge && !reviewData['is_read'] && ((reviewData['reply']?.length || 0) === 0)) &&
                    <View style={{ position: 'absolute', right: 0, top: 0, borderRadius: 6, paddingVertical: 6, paddingHorizontal: 12, backgroundColor: GLOBAL.COLOR.MAIN }}>
                        <Text style={{ fontWeight: 'bold', color: 'white', fontSize: 14 }}>
                            New
                        </Text>
                    </View>
                }

                {/* Photo */}
                {
                    hasPhotos &&
                    <View style={{ alignSelf: 'stretch', height: PHOTO_SIZE, marginTop: 24, flexDirection: 'row' }}>
                        {reviewData.photos.map((item, index) => (
                            (index < DISPLAY_PHOTO_COUNT) &&
                            <TouchableOpacity
                                onPress={() => {
                                    setCurrentPhotoIndex(index);
                                    setPhotoCarouselOpened(true);
                                }}
                                style={{ width: PHOTO_SIZE, height: PHOTO_SIZE, marginRight: 8, backgroundColor: GLOBAL.COLOR.BACKGROUND_GREY }}>
                                <Image
                                    key={item.key}
                                    source={{ uri: item['path_webp'] || item['path'] }}
                                    style={{ flex: 1 }}
                                    resizeMode={'cover'}
                                />

                                {/* Last Item Overlay */}
                                {
                                    ((index === (reviewData.photos.length - 1)) && (remainingPhotoCount > 0)) &&
                                    <View style={{ position: 'absolute', left: 0, right: 0, bottom: 0, top: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', alignItems: 'center', justifyContent: 'center' }}>
                                        <Text style={{ color: 'white', fontWeight: '500', fontSize: 32 }}>
                                            +{remainingPhotoCount}
                                        </Text>
                                    </View>
                                }
                            </TouchableOpacity>
                        ))}
                    </View>
                }
            </View>

            {/* Total number of replies / Vendor Response */}
            {
                (reviewData['reply'] && reviewData['reply'].length > 0) &&
                (
                    showTotalResponses ?
                        <View style={{
                            position: 'absolute', right: parentPadding, top: parentPadding,
                            borderWidth: 2, borderRadius: 6, borderColor: GLOBAL.COLOR.BACKGROUND_GREY,
                            paddingHorizontal: 12, paddingVertical: 6
                        }}>
                            <Text style={{ fontWeight: 'bold', color: GLOBAL.COLOR.BASIC.BLACK_TWO, fontSize: 16 }}>
                                {reviewData['reply'].length + ' repl' + (reviewData['reply'].length > 1 ? 'ies' : 'y')}
                            </Text>
                        </View>
                        :
                        null
                )
            }

            {/* Lightbox - Truck Photos */}
            <Lightbox
                plugins={[Captions]}
                open={photoCarouselOpened}
                close={() => setPhotoCarouselOpened(false)}
                index={currentPhotoIndex}
                on={{ view: ({ index }) => setCurrentPhotoIndex(index) }}
                slides={reviewData.photos.map((photo) => ({ src: photo['path_webp'] || photo['path'] }))}
                carousel={{ imageFit: 'contain' }}
                styles={{ container: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
            />
        </View>
    )
}

// region Props
ReviewItem.propTypes = {
    maxLines: PropTypes.number,
    reviewData: PropTypes.object,
    onReplyToVendorPressed: PropTypes.func,
    parentPadding: PropTypes.number,
    showTotalResponses: PropTypes.bool,
    hideVendorResponse: PropTypes.bool,
    shortenReview: PropTypes.bool,
    showUnreadBadge: PropTypes.bool,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};

ReviewItem.defaultProps = {
    maxLines: null,
    reviewData: null,
    onReplyToVendorPressed: () => {},
    parentPadding: 24,
    showTotalResponses: false,
    hideVendorResponse: true,
    shortenReview: false,
    showUnreadBadge: true,
    style: {}
};
// endregion
